module.exports = __webpack_public_path__ + "img/blank1.a4d17142.png";